export const strings = {
    title: 'Hello',
    language: 'Language',
    titleTutorial: 'App G13BJJ - Tutorial',
    menuStudents: 'Students',
    menuInstructors: 'Professors',
    subtitleTutorial: 'Choose from the subjects below to find out more about the features of the App G13BJJ',
    tutorialFull: 'Complete tutorial',
    questionsGroup: {
        'questionGroup1': 'Language',
        'questionGroup2': 'Access account',
        'questionGroup3': 'Trainings and check-ins',
        'questionGroup4': 'Schools',
        'questionGroup5': 'Annual lesson plan',
        'questionGroup6': 'Track progress',
        'questionGroup7': 'Kids',
        'questionGroup8': 'Hierarchy of Techniques',
        'questionGroup9': 'My students',
        'questionGroup10': 'My school(s)',
        'questionGroup11': 'My classes of the week',
    },
    questions: {
        'question1': 'Change the language',
        'question2': 'Create an account (sign up now)',
        'question3': 'Link to a G13 School',
        'question4': 'Login with an existing login account',
        'question5': 'I forgot my password',
        'question6': 'Change password',
        'question7': 'Change name, school, professor and/or date of birth',
        'question8': 'Edit profile picture',
        'question9': 'View trainings for an school',
        'question10': 'Check in',
        'question11': 'View trainings performed',
        'question12': 'See list of G13BJJ Schools',
        'question13': 'Create a School',
        'question14': 'View annual lesson plan',
        'question15': 'View belt progress',
        'question16': 'Register kids students',
        'question17': 'Edit the registration of kids students',
        'question18': 'Check-in for a kids students',
        'question19': 'View technique hierarchy and videos of the positions',
        'question20': 'List my students',
        'question21': 'List my new students',
        'question22': 'Approve list of new students',
        'question23': "Approve a student's registration",
        'question24': 'View student progress',
        'question25': 'Reset the number of check-ins assigned in the register',
        'question26': 'Edit student data (graduation information only)',
        'question27': 'Assign a new grade to the student',
        'question28': 'Send a message to the student',
        'question29': 'Temporarily deactivate student registration - (The student will remain associated with the school and with the professor but will not be able to check-in trainings.)',
        'question30': 'Remove the student from the School. (The student will be disassociated from the school and the professor)',
        'question31': 'See my school',
        'question32': 'Edit my school',
        'question33': 'Create/edit class schedule for my school',
        'question34': 'Add/remove professors from my school',
        'question35': 'View my classes for the week',
        'question36': 'Create my classes of the week',
        'question37': 'Include videos of positions in class',
        'question38': 'Edit an already created class',
        'question39': 'Open a class for students to check-in',
        'question40': 'See check-ins performed in my class',
        'question41': 'Add (or remove) a student to the class (check in for the student)',
        'question42': 'View a list of students present in class who are eligible to earn a stripe',
        'question43': 'Assign grades to students from check-ins listing',
    },
}